import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ValidationService } from "../../../common/validationservice";
import { MainAppComponent } from "../../../layout/layout.component";
import { LabModel } from "../../../common/viewModels/Admin/LabModel";
import { CustomerModel } from "../../../common/viewModels/Admin/CustomerModel";
import { FormatService } from "../../../common/formatService";
import "rxjs/add/operator/map";
import { MediaFileCategoryTypesEnum } from "../../../common/enumcontainer.enum";
import { MediaFileModel } from "../../../common/viewModels/Admin/DigitalSignatureModel";

@Component({
  selector: "addeditjobcard",
  templateUrl: "./addeditjobcard.component.html",
  styleUrls: ["./addeditjobcard.component.scss"],
})
export class AddEditJobCard implements OnInit {
  addJobCardForm: FormGroup;
  labs: LabModel[];
  customers: CustomerModel[];
  lstEngineers: any[];
  lstSampleReceivedTypes: any;
  isSubmitted: boolean = false;
  numbers = "^[0-9]+$";
  jobCarId: number;
  showCourier: boolean = true;
  showSampleEngineer: boolean = false;
  lstSampleTypes: any[];
  lstGraphTypes: any[];
  lstMediaFiles: MediaFileModel[];
  lstTM: MediaFileModel[];
  lstAuthSign: MediaFileModel[];

  constructor(
    public _router: Router,
    private _mApp: MainAppComponent,
    private formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _formatService: FormatService,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService,
    private _toastrService: ToastrService,
  ) {}
  ngOnInit() {
    this.GetLabs();
    this.GetCustomers();
    this.GetMinSampleReceivedTypesList();
    this.GetSampleCOllectionEngineers();
    this.GetSampleTypes();
    this.GetGraphTemplateTypesForDDL();
    this.GetMediaFiles();
    this.addJobCardForm = this.formBuilder.group({
      JobCardId: [0],
      LabId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      CustomerId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      JobCardNumber: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
          Validators.pattern(this._validationService.numberPattern),
        ]),
      ],
      PoNumber: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      CourierCompany: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      AwbNo: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(50)]),
      ],
      SampleReceivedTypeId: [""],
      SampleCollectionEngineerId: [""],
      DispatchedDate: [null],
      ReceivedDate: [null, Validators.compose([Validators.required])],
      Notes: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(250),
        ]),
      ],
      BottlesReceived: [
        "",
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(250),
          Validators.pattern(this.numbers),
        ]),
      ],
      SampleTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      GraphTemplateTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      WorkOrderNO: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      ReportDate: [null, Validators.compose([Validators.required])],
      Specification: [""],
      IsNBLLogo: [false],
      TechMgrSignId: "",
      AuthorizedSignId: "",
    });
    let jobId = this._route.snapshot.params["id"];
    this.jobCarId = this._route.snapshot.params["id"];
    if (jobId != 0 && jobId != "" && jobId != undefined) {
      this.GetJobCardDetailsById(jobId);
    } else {
      this.GetMaxJobCardValue();
    }
  }

  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) {
          let lstLabs = data.json().Result;
          if (this._mApp.currentUserLabIds && lstLabs)
            lstLabs = lstLabs.filter((m) =>
              this._mApp.currentUserLabIds.includes(m.LabId),
            );
          this.labs = lstLabs;
          let jobCardId = this._route.snapshot.params["id"];
          if (!(jobCardId > 0)) {
            if (this.labs.length == 1) {
              this.addJobCardForm.controls["LabId"].setValue(
                this.labs[0].LabId,
              );
            }
          }
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.customers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  GetGraphTemplateTypesForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetGraphTempleteTypeList).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstGraphTypes = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetJobCardDetailsById(id) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetJobCardByJobCardId + id).subscribe(
      (data) => {
        this._mApp.HideLoader();
        let jobCardDetails = data.json().Result;
        if (jobCardDetails != null && jobCardDetails != undefined) {
          jobCardDetails.DispatchedDate = this._formatService.formatNewDate(
            jobCardDetails.DispatchedDate,
          );
          jobCardDetails.ReceivedDate = this._formatService.formatNewDate(
            jobCardDetails.ReceivedDate,
          );
          jobCardDetails.ReportDate = this._formatService.formatNewDate(
            jobCardDetails.ReportDate,
          );
          this.addJobCardForm.setValue(jobCardDetails);
          if (
            jobCardDetails.SampleReceivedTypeId != null &&
            jobCardDetails.SampleReceivedTypeId != ""
          )
            this.ShowHideCourier(jobCardDetails.SampleReceivedTypeId);
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.addJobCardForm.valid) {
      this._mApp.ShowLoader();
      let jobCard = this.addJobCardForm.value;
      jobCard.ReceivedDate = this._formatService.formatDate(
        jobCard.ReceivedDate,
      );
      jobCard.DispatchedDate = this._formatService.formatDate(
        jobCard.DispatchedDate,
      );
      jobCard.ReportDate = this._formatService.formatDate(jobCard.ReportDate);

      this._http.post(this._appUrl.AddUpdateJobCard, jobCard).subscribe(
        (data) => {
          this._mApp.HideLoader();
          if (data.json().Result == "Job Card Details Updated Successfully") {
            this._toastrService.success(data.json().Result, "");
            this._router.navigate(["/jobcardchars", this.jobCarId]);
          } else if (data.json().Result != 0) {
            this._toastrService.success("Job Card Added Successfully");
            this._router.navigate(["/jobcardchars", data.json().Result]);
          }
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
    }
  }

  GetMaxJobCardValue() {
    this._http.get(this._appUrl.GetMaxJobCardValue).subscribe(
      (data) => {
        if (data.json().Result != null && data.json().Result != "") {
          var maxNo = Number(data.json().Result);
          maxNo = maxNo + 1;
          this.addJobCardForm.controls["JobCardNumber"].setValue(maxNo);
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetMinSampleReceivedTypesList() {
    this._http.get(this._appUrl.GetMinSampleReceivedTypesList).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstSampleReceivedTypes = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  ShowHideCourier(val) {
    if (val == 1) {
      this.showSampleEngineer = true;
      this.showCourier = false;
    } else if (val == 2) {
      this.showCourier = true;
      this.showSampleEngineer = false;
    }
  }

  GetSampleCOllectionEngineers() {
    //Role id 8 is Sample collection Engineer
    this._http.get(this._appUrl.GetUsersBasedOnRole + 8).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstEngineers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetPurchaseOrderFromCustomer(customerId) {
    this._http
      .get(this._appUrl.GetPurchaseOrderFromCustomer + customerId)
      .subscribe(
        (data) => {
          if (data.json().Result != null)
            this.addJobCardForm.controls["PoNumber"].setValue(
              data.json().Result,
            );
        },
        (error) => {
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  GetSampleTypes() {
    this._http.get(this._appUrl.GetMinInfoSampleTypes).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstSampleTypes = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }

  GetMediaFiles() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetMediaFiles).subscribe(
      (data) => {
        this._mApp.HideLoader();
        const res = data.json().Result || [];

        this.lstMediaFiles = res;

        this.lstTM = res.filter(
          (x) =>
            x.MediaFileCategoryTypeId ===
            MediaFileCategoryTypesEnum.Technical_Manager,
        );
        this.lstAuthSign = res.filter(
          (x) =>
            x.MediaFileCategoryTypeId ===
            MediaFileCategoryTypesEnum.Authorized_Signature,
        );
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error("Failed to load media files data");
      },
    );
  }
}
